export enum IgniteSubscriptionSubscribePageType
{
  None = 0,

  /*
   * The user should see the new user subscription page. They might not be a new user, they might be returning
   * after a long time (and are granted a new free trial, even though they already have a Chargebee account).
  */
  NewUser = 1,

  /*
   * The user should see a page indicating that their trial has expired, and they now need to pay to get access.
  */
  TrialExpired = 2,

  /*
   * The user should see a page stating that they need to reactivate their subscription, but that they must
   * contact LGMS tech support to do so.
  */
  ReactivateContactLgms = 3,
}

export interface SubscriptionStatus {
  active: boolean;
  accountOwner: boolean;
  accessManager: boolean;
  broker: boolean;
  numberOfLicences: number | null;
  trialEndDate: string | null;
  subscribePageType: IgniteSubscriptionSubscribePageType;
}
